export const ConfirmationFilters = {
    UPDATE_EMAIL_FLAG: 'IN_MEMORY.CONFIRMATION.UPDATE_EMAIL_FLAG',
};

export const updateEmailFlag = bool => ({
    type: ConfirmationFilters.UPDATE_EMAIL_FLAG,
    bool
});